import { useQuery } from '@tanstack/react-query';

import { TeamMemberModel, UserRole } from '../../models/user.model';

import API from '../../services/api';

const getUsers = async (role?: UserRole): Promise<TeamMemberModel[]> => {
    const { data } = await API.getUsers({ role: role });
    return data;
};

export default function useTeamMemberQuery(role?: UserRole) {
    return useQuery({
        queryKey: ['team_members', role],
        queryFn: () => getUsers(role),
    });
}
